export default {
  defaultProps: {
    underline: "none",
  },
};
